/* AIJ header + sidebar — Pashupati Jewellers */
(function () {
  'use strict';

  function init() {
    var hd = document.getElementById('AijHeader');
    if (!hd || hd.dataset.aijInit) return;
    hd.dataset.aijInit = '1';

    var isHome = hd.hasAttribute('data-home');
    var root = document.documentElement;

    /* ---- height variable for the inner-page spacer ---- */
    function setH() { root.style.setProperty('--aij-hd-h', hd.offsetHeight + 'px'); }
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(hd);
    setH();

    /* ---- scroll states: over hero / scrolled / tucked nav ---- */
    var lastY = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY;
      var searchOpen = panel && panel.classList.contains('is-open');
      hd.classList.toggle('is-scrolled', y > 40 || (!isHome && y > 0));
      if (isHome) hd.classList.toggle('is-over', y <= 40 && !searchOpen);
      if (y > 220 && y > lastY + 4 && !searchOpen) hd.classList.add('is-tucked');
      else if (y < lastY - 4 || y <= 220) hd.classList.remove('is-tucked');
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

    /* ---- search panel ---- */
    var panel = document.getElementById('AijSearch');
    var sBtns = document.querySelectorAll('[data-aij-search]');
    function closeSearch() {
      if (!panel) return;
      panel.classList.remove('is-open');
      sBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      onScroll();
    }
    sBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!panel) return;
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        sBtns.forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        if (open) { hd.classList.remove('is-over', 'is-tucked'); var i = panel.querySelector('input[type="search"]'); if (i) setTimeout(function () { i.focus(); }, 60); }
        else onScroll();
      });
    });
    document.addEventListener('click', function (e) {
      if (panel && panel.classList.contains('is-open') && !panel.contains(e.target)) closeSearch();
    });

    /* ---- "Products" category dropdown: hover on mouse, tap/keyboard elsewhere ---- */
    var megaBtn = hd.querySelector('[data-aij-mega-btn]');
    var mega = hd.querySelector('[data-aij-mega]');
    if (megaBtn && mega) {
      var canHover = window.matchMedia('(hover: hover)').matches;
      var t = null;
      var setMega = function (open) {
        clearTimeout(t);
        hd.classList.toggle('is-mega', open);
        megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { closeSearch(); hd.classList.remove('is-tucked'); }
      };
      var later = function () { clearTimeout(t); t = setTimeout(function () { setMega(false); }, 180); };
      [megaBtn, mega].forEach(function (el) {
        el.addEventListener('mouseenter', function () { if (canHover) setMega(true); });
        el.addEventListener('mouseleave', function () { if (canHover) later(); });
      });
      megaBtn.addEventListener('click', function (e) {
        /* on touch, the first tap opens the panel instead of following the link */
        if (!canHover && !hd.classList.contains('is-mega')) { e.preventDefault(); setMega(true); }
      });
      megaBtn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); setMega(true); var f = mega.querySelector('a'); if (f) f.focus(); }
      });
      hd.addEventListener('focusout', function () { setTimeout(function () { if (!mega.contains(document.activeElement) && document.activeElement !== megaBtn) setMega(false); }, 0); });
      document.addEventListener('click', function (e) { if (!hd.contains(e.target)) setMega(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hd.classList.contains('is-mega')) { setMega(false); megaBtn.focus(); } });
    }

    /* ---- sidebar drawer ---- */
    var drawer = document.getElementById('AijDrawer');
    var dPanel = drawer && drawer.querySelector('.aij-drawer__panel');
    var opener = null;

    function focusables() {
      return Array.prototype.filter.call(
        dPanel.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; });
    }
    function openMenu(from) {
      if (!drawer) return;
      closeSearch();
      opener = from || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      root.classList.add('aij-lock');
      document.querySelectorAll('[data-aij-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { var c = drawer.querySelector('.aij-drawer__close'); if (c) c.focus({ preventScroll: true }); }, 80);
    }
    function closeMenu() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('aij-lock');
      document.querySelectorAll('[data-aij-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    document.querySelectorAll('[data-aij-menu-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openMenu(b); });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-aij-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* swipe left to close on touch */
      var sx = null;
      dPanel.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      dPanel.addEventListener('touchend', function (e) {
        if (sx === null) return;
        if (e.changedTouches[0].clientX - sx < -70) closeMenu();
        sx = null;
      }, { passive: true });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMenu(); closeSearch();
    });

    window.AIJMenu = { open: openMenu, close: closeMenu };

    /* theme editor: open the drawer while a drawer block is selected */
    document.addEventListener('shopify:block:select', function (e) { if (drawer && drawer.contains(e.target)) openMenu(); });
    document.addEventListener('shopify:block:deselect', function (e) { if (drawer && drawer.contains(e.target)) closeMenu(); });

    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
